import { render, staticRenderFns } from "./AccBookingEmailTemplateDetail.vue?vue&type=template&id=0c87494c&scoped=true"
import script from "./AccBookingEmailTemplateDetail.vue?vue&type=script&lang=js"
export * from "./AccBookingEmailTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87494c",
  null
  
)

export default component.exports